// CalendarNavControls.jsx

import React, { useState } from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './CalendarNavControls.css';

// Icons
import Icon from 'svg/Icon';

/**
 * CalendarNavControls
 *
 * @returns {ReactNode} The rendered component.
 */
const CalendarNavControls = ({
    title,
    todayLabel = 'Today',
    prevAriaLabel,
    nextAriaLabel,
    onToday,
    onPrev,
    onNext,
}) => {

    // ----- CONTEXT ----- //

    const { theme } = useTheme();

    // ----- STATE ----- //

    const [hoveredControl, setHoveredControl] = useState(null);
    // ----- RENDER ----- //

    return (
        <div
          className="calendar-nav-controls"
          style={{
            borderBottom: `1px solid ${theme.backgroundMuted}`,
          }}
        >

            {/* TITLE */}
            <div
              className="calendar-nav-controls-title"
            >
                {title}
            </div>

            {/* ACTIONS */}
            <div className="calendar-nav-controls-actions">

                {/* TODAY */}
                <button
                  className="calendar-nav-controls-today"
                  style={{
                    background: hoveredControl === 'today' ? theme.backgroundHover : theme.backgroundMuted,
                    borderColor: hoveredControl === 'today' ? theme.foregroundMuted : theme.foregroundMuted,
                  }}
                  type="button"
                  onClick={onToday}
                  onMouseEnter={() => setHoveredControl('today')}
                  onMouseLeave={() => setHoveredControl(null)}
                >
                    {todayLabel}
                </button>

                {/* CHEVRON */}
                <button
                  className="calendar-nav-controls-chevron"
                  style={{
                        background: hoveredControl === 'prev' ? theme.backgroundHover : theme.backgroundMuted,
                        borderColor: hoveredControl === 'prev' ? theme.foregroundMuted : theme.foregroundMuted,
                    }}
                  type="button"
                  aria-label={prevAriaLabel}
                  onClick={onPrev}
                  onMouseEnter={() => setHoveredControl('prev')}
                  onMouseLeave={() => setHoveredControl(null)}
                >
                    <Icon
                      iconKey="chevron_left"
                      width={18}
                      height={18}
                      color={theme.foreground}
                    />
                </button>

                {/* CHEVRON */}
                <button
                  className="calendar-nav-controls-chevron"
                  style={{
                        background: hoveredControl === 'next' ? theme.backgroundHover : theme.backgroundMuted,
                        borderColor: hoveredControl === 'next' ? theme.foregroundMuted : theme.foregroundMuted,
                    }}
                  type="button"
                  aria-label={nextAriaLabel}
                  onClick={onNext}
                  onMouseEnter={() => setHoveredControl('next')}
                  onMouseLeave={() => setHoveredControl(null)}
                >
                    <Icon
                      iconKey="chevron_right"
                      width={18}
                      height={18}
                      color={theme.foreground}
                    />
                </button>
            </div>
        </div>
    );
};

// Dev Tools
CalendarNavControls.displayName = 'CalendarNavControls';

export default CalendarNavControls;
